import { Typography } from '@breetometer/components';
import { Amount, RowSection } from 'BreetComponents';

import type { IRowBalance } from '../DialogWithdrawalHistoryDetails.helpers';

const RowBalance = ({ symbol, before, after }: IRowBalance) => (
	<RowSection.Tuple
		rowClass='hide-during-screenshot'
		leftLabel='Balance Before'
		leftComponent={
			<div className='transactiondetails_value'>
				<Typography className='color-neutral-50'>
					{symbol}
					<Amount>{before}</Amount>
				</Typography>
			</div>
		}
		rightLabel='Balance After'
		rightComponent={
			<div className='transactiondetails_value'>
				<Typography className='color-neutral-50'>
					{symbol}
					<Amount>{after}</Amount>
				</Typography>
			</div>
		}
	/>
);

export default RowBalance;
